/*
 * @Description:
 * @Author: Rieko
 * @LastEditors: Rieko
 * @PersonalStation:
 * @Date: 2022-04-07 16:32:06
 * @LastEditTime: 2022-04-14 20:18:01
 */
import React, { useState } from 'react';
import { SearchOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';
import { Checkbox, Tooltip } from 'antd';
import { makeStyles } from '@material-ui/styles';

const CheckboxGroup = Checkbox.Group;

const useStyles = makeStyles(theme => ({
  filterDropdownBox: {
    minWidth: '240px',

    '& .ant-checkbox-group': {
      width: '100%',
      maxHeight: 320,
      paddingTop: '4px',
      paddingBottom: '4px',
      overflowY: 'auto',
    },

    '& .ant-checkbox-wrapper': {
      display: 'block',
      margin: '0',
      paddingLeft: '12px',
      paddingTop: '5px',
      paddingBottom: '5px',
      fontSize: '14px',
      lineHeight: '22px',

      color: 'rgba(0, 0, 0, 0.85)',
      '&:hover': {
        backgroundColor: theme.colors.gray3,
      },
    },
    '& .ant-checkbox-wrapper-checked': {
      backgroundColor: `${theme.colors.mainGreen1} !important`,
      color: theme.colors.mainGreen6,
    },
  },
}));
const NewCheckBoxGroup = props => {
  const { options, value, onChange, mode } = props;
  const classes = useStyles();
  if (mode === 'reconciliationSearch')
    return (
      <div className={classes.filterDropdownBox}>
        <CheckboxGroup value={value} onChange={onChange}>
          {options &&
            options.length > 0 &&
            options.map(item => {
              return (
                <Tooltip placement="right" key={item.value} title={item.label}>
                  <Checkbox value={item.value}>{item.label}</Checkbox>
                </Tooltip>
              );
            })}
        </CheckboxGroup>
      </div>
    );
  return (
    <div className={classes.filterDropdownBox}>
      <CheckboxGroup options={options} value={value} onChange={onChange} />
    </div>
  );
};
NewCheckBoxGroup.propTypes = {
  options: PropTypes.array.isRequired,
  value: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
};
export default NewCheckBoxGroup;
